import React from 'react';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import Contact from '../../../models/Contact';
import StyledFieldDescription from '../../styles/StyledFieldDescription';
import { StyledLabel } from '../../styles/styles';

interface AdminAssistContactSelectorProps {
  contactOptions: Contact[];
  contactLoading: boolean;
  selectedContact: Contact | null;
  onSearchChange: (value: string) => void;
  onContactChange: (contact: Contact | null) => void;
}

export default function AdminAssistContactSelector({
  contactOptions,
  contactLoading,
  selectedContact,
  onSearchChange,
  onContactChange,
}: AdminAssistContactSelectorProps) {
  return (
    <Box sx={{ mb: 3 }}>
      <StyledLabel stacked>Test Context — Contact</StyledLabel>
      <StyledFieldDescription stacked>
        Select a contact before testing. Their portfolio becomes the Vera assist context.
      </StyledFieldDescription>
      <Autocomplete
        sx={{ mt: 1.5 }}
        options={contactOptions}
        getOptionLabel={(contact) => `${contact.firstName} ${contact.lastName} (${contact.email})`}
        loading={contactLoading}
        value={selectedContact}
        onInputChange={(_, value) => onSearchChange(value)}
        onChange={(_, value) => onContactChange(value)}
        renderInput={(params) => (
          <TextField
            {...params}
            label="Search contact"
            size="small"
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <>
                  {contactLoading && <CircularProgress size={16} />}
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
          />
        )}
      />
    </Box>
  );
}
